export default __webpack_public_path__ + "static/media/adventure-bible-logo.f757b22c.png";